
import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, ControlType, DataListBase, DropdownControlSchema, Filter, GridInfo, ModelSchema, Operator } from 'tnx-shared';
import { AddressService } from 'tnx-admin-service/address/services';
import { ENUM_DON_VI_HANH_CHINH } from 'tnx-admin-service/address/models';
import { MenuItem } from 'tn-custom-primeng/api';
@Component({
    selector: 'address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    providers: [ComponentContextService],
})
export class AddressComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    sourceDonViHanhChinh = [];
    constructor(
        protected _injector: Injector,
        protected _addressService: AddressService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._addressService;
        this.sourceDonViHanhChinh.push(
            { value: ENUM_DON_VI_HANH_CHINH.THANH_PHO, label: 'Tỉnh/Thành Phố' },
            { value: ENUM_DON_VI_HANH_CHINH.QUAN_HUYEN, label: 'Quận/Huyện' },
            { value: ENUM_DON_VI_HANH_CHINH.PHUONG_XA, label: 'Phường/Xã' },
            { value: ENUM_DON_VI_HANH_CHINH.DUONG, label: 'Đường' }
        );

        this.setting.modelSchemas = [
            new ModelSchema({
                field: 'sort',
                name: 'Sắp xếp',
                fullName: 'Sắp xếp',
                description: 'Sắp xếp',
                dataType: 'int'
            }),
            new ModelSchema({
                field: 'parentID',
                name: 'Địa chỉ cha',
                fullName: 'Địa chỉ cha',
                description: 'Địa chỉ cha',
                dataType: 'string'
            }),
            new ModelSchema({
                field: 'code',
                name: 'Mã',
                fullName: 'Mã',
                description: 'Mã',
                dataType: 'string'
            }),
            new ModelSchema({
                field: 'name',
                name: 'Tên địa chỉ hành chính',
                fullName: 'Tên địa chỉ hành chính',
                description: 'Tên địa chỉ hành chính',
                dataType: 'string'
            }),
            new ModelSchema({
                field: 'nameWithoutSpace',
                name: 'Tên không có khoảng trống',
                fullName: 'Tên không có khoảng trống',
                description: 'Tên không có khoảng trống',
                dataType: 'string'
            }),
            new ModelSchema({
                field: 'created',
                name: 'Ngày tạo',
                fullName: 'Ngày tạo',
                description: 'Ngày tạo',
                dataType: 'datetime'
            })
        ]

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'sort',
                sort: false,
                width: '80px',
                min: 0
            }),
            new ColumnSchemaBase({
                field: 'parentID',
                sort: false,
                controlType: ControlType.dropdown,
                baseService: this._addressService,
                defaultFilters: [
                    this.newFilter('level', Operator.equal, ENUM_DON_VI_HANH_CHINH.THANH_PHO)
                ],
                valueField: 'idRoot',
                displayField: 'name'
            }),
            new ColumnSchemaBase({
                field: 'code',
                sort: true,
                fullTextSearch: true,
                width: '80px'
            }),
            new ColumnSchemaBase({
                field: 'name',
                sort: true,
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'nameWithoutSpace',
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'created'
            })
        ];

        this.searchSchema.level = new DropdownControlSchema({
            label: 'Chọn đơn vị hành chính',
            showClear: false
        });
        this.searchData.level = ENUM_DON_VI_HANH_CHINH.PHUONG_XA;
        this.setting.objectName = 'Phường/Xã 2';
        this.setting.multipleCheckWhenClickRow = true;

        this.setting.filterTemplateAdvs = [
            new Filter({ field: 'code', operator: Operator.contain, sourceField: 'code' }),
            new Filter({ field: 'name', operator: Operator.contain, sourceField: 'name' }),
            new Filter({ field: 'created', operator: Operator.greaterThanEqual, sourceField: 'created', subField: 0 }),
            new Filter({ field: 'created', operator: Operator.lowerThanEqual, sourceField: 'created', subField: 1 })
        ];
        this.setting.popupSize.width = 800;
        this.setting.popupSize.height = 500;
        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo?: GridInfo) {
        gridInfo.filters.splice(0, 0,
            { field: 'level', operator: Operator.equal, value: this.searchData.level }
        );
    }

    onSelect(value) {
        if (this.searchData.level == ENUM_DON_VI_HANH_CHINH.THANH_PHO) {
            this.setting.objectName = 'Tỉnh/Thành Phố';
            this._triggerProcessData();
        }
        else if (this.searchData.level == ENUM_DON_VI_HANH_CHINH.QUAN_HUYEN) {
            this.setting.objectName = 'Quận/Huyện';
            this._triggerProcessData();
        }
        else if (this.searchData.level == ENUM_DON_VI_HANH_CHINH.PHUONG_XA) {
            this.setting.objectName = 'Phường/Xã';
            this._triggerProcessData();
        }
        else {
            this.setting.objectName = 'Đường';
            this._triggerProcessData();
        }
    }

    getMenuButtons(rowData): MenuItem[] {
        this.rowDataCurrent = rowData;
        return [
            // { label: 'Chạy quy trình', icon: 'pi pi-list', command: this.startWorkflow.bind(this) }
        ];
    }
}

